// lib/search/geo-data.ts
// Generated from /api/search2/facets — shortnames + MSA tables

export const STATE_SLUGS: Record<string, { code: string; name: string }> = {
  "alabama": { code: "AL", name: "Alabama" },
  "alaska": { code: "AK", name: "Alaska" },
  "arizona": { code: "AZ", name: "Arizona" },
  "arkansas": { code: "AR", name: "Arkansas" },
  "california": { code: "CA", name: "California" },
  "colorado": { code: "CO", name: "Colorado" },
  "connecticut": { code: "CT", name: "Connecticut" },
  "delaware": { code: "DE", name: "Delaware" },
  "district-of-columbia": { code: "DC", name: "District of Columbia" },
  "florida": { code: "FL", name: "Florida" },
  "georgia": { code: "GA", name: "Georgia" },
  "hawaii": { code: "HI", name: "Hawaii" },
  "idaho": { code: "ID", name: "Idaho" },
  "illinois": { code: "IL", name: "Illinois" },
  "indiana": { code: "IN", name: "Indiana" },
  "iowa": { code: "IA", name: "Iowa" },
  "kansas": { code: "KS", name: "Kansas" },
  "kentucky": { code: "KY", name: "Kentucky" },
  "louisiana": { code: "LA", name: "Louisiana" },
  "maine": { code: "ME", name: "Maine" },
  "maryland": { code: "MD", name: "Maryland" },
  "massachusetts": { code: "MA", name: "Massachusetts" },
  "michigan": { code: "MI", name: "Michigan" },
  "minnesota": { code: "MN", name: "Minnesota" },
  "mississippi": { code: "MS", name: "Mississippi" },
  "missouri": { code: "MO", name: "Missouri" },
  "montana": { code: "MT", name: "Montana" },
  "nebraska": { code: "NE", name: "Nebraska" },
  "nevada": { code: "NV", name: "Nevada" },
  "new-hampshire": { code: "NH", name: "New Hampshire" },
  "new-jersey": { code: "NJ", name: "New Jersey" },
  "new-mexico": { code: "NM", name: "New Mexico" },
  "new-york": { code: "NY", name: "New York" },
  "north-carolina": { code: "NC", name: "North Carolina" },
  "north-dakota": { code: "ND", name: "North Dakota" },
  "ohio": { code: "OH", name: "Ohio" },
  "oklahoma": { code: "OK", name: "Oklahoma" },
  "oregon": { code: "OR", name: "Oregon" },
  "pennsylvania": { code: "PA", name: "Pennsylvania" },
  "rhode-island": { code: "RI", name: "Rhode Island" },
  "south-carolina": { code: "SC", name: "South Carolina" },
  "south-dakota": { code: "SD", name: "South Dakota" },
  "tennessee": { code: "TN", name: "Tennessee" },
  "texas": { code: "TX", name: "Texas" },
  "utah": { code: "UT", name: "Utah" },
  "vermont": { code: "VT", name: "Vermont" },
  "virginia": { code: "VA", name: "Virginia" },
  "washington": { code: "WA", name: "Washington" },
  "west-virginia": { code: "WV", name: "West Virginia" },
  "wisconsin": { code: "WI", name: "Wisconsin" },
  "wyoming": { code: "WY", name: "Wyoming" },
} as const;

export const STATE_CODE_TO_SLUG: Record<string, string> = Object.fromEntries(
  Object.entries(STATE_SLUGS).map(([slug, { code }]) => [code, slug])
);

// Metro areas grouped by state code — exact webname values from shortnames table
export const METRO_SLUGS: Record<string, Record<string, string>> = {
  "AK": {
    "anchorage": "Anchorage",
  },
  "AL": {
    "birmingham": "Birmingham",
    "huntsville": "Huntsville",
    "mobile": "Mobile",
    "montgomery": "Montgomery",
  },
  "AR": {
    "fayetteville": "Fayetteville",
    "fort-smith": "Fort Smith",
    "little-rock": "Little Rock",
  },
  "AZ": {
    "gila-valley": "Gila Valley",
    "mohave-county": "Mohave County",
    "nogales": "Nogales",
    "northern-arizona": "Northern Arizona",
    "phoenix": "Phoenix",
    "tucson": "Tucson",
    "yuma": "Yuma",
  },
  "CA": {
    "bakersfield": "Bakersfield",
    "fresno": "Fresno",
    "los-angeles": "Los Angeles",
    "merced": "Merced",
    "modesto": "Modesto",
    "oakland": "Oakland",
    "oxnard": "Oxnard",
    "riverside": "Riverside",
    "sacramento": "Sacramento",
    "salinas": "Salinas",
    "san-diego": "San Diego",
    "san-francisco": "San Francisco",
    "san-jose": "San Jose",
    "san-luis-obispo": "San Luis Obispo",
    "santa-ana": "Santa Ana",
    "santa-barbara": "Santa Barbara",
    "santa-rosa": "Santa Rosa",
    "stockton": "Stockton",
    "vallejo": "Vallejo",
    "visalia": "Visalia",
  },
  "CO": {
    "boulder": "Boulder",
    "colorado-springs": "Colorado Springs",
    "denver": "Denver",
    "fort-collins": "Fort Collins",
    "greely": "Greely",
  },
  "CT": {
    "bridgeport": "Bridgeport",
    "hartford": "Hartford",
    "new-haven": "New Haven",
    "norwich-new-london": "Norwich New London",
  },
  "DC": {
    "washington-dc": "Washington DC",
  },
  "DE": {
    "wilmington": "Wilmington",
  },
  "FL": {
    "cape-coral": "Cape Coral",
    "deltona": "Deltona",
    "fort-lauderdale": "Fort Lauderdale",
    "gainesville": "Gainesville",
    "jacksonville": "Jacksonville",
    "lakeland": "Lakeland",
    "miami": "Miami",
    "ocala": "Ocala",
    "orlando": "Orlando",
    "palmbay": "Palm Bay",
    "pensacola": "Pensacola",
    "port-st-lucie": "Port St. Lucie",
    "sarasota": "Sarasota",
    "tallahassee": "Tallahassee",
    "tampa": "Tampa",
    "west-palm-beach": "West Palm Beach",
  },
  "GA": {
    "atlanta": "Atlanta",
    "augusta-richmond": "Augusta",
    "columbus-georgia": "Columbus",
    "macon": "Macon",
    "savannah": "Savannah",
  },
  "HI": {
    "honolulu": "Honolulu",
  },
  "IA": {
    "cedar-rapids": "Cedar Rapids",
    "davenport": "Davenport",
    "des-moines": "Des Moines",
  },
  "ID": {
    "boise": "Boise",
  },
  "IL": {
    "chicago": "Chicago",
    "lake-county": "Lake County",
    "peoria": "Peoria",
    "rockford": "Rockford",
  },
  "IN": {
    "evansville": "Evansville",
    "fort-wayne": "Fort Wayne",
    "gary": "Gary",
    "indianapolis": "Indianapolis",
    "south-bend": "South Bend",
  },
  "KS": {
    "wichita": "Wichita",
  },
  "KY": {
    "lexington": "Lexington",
    "louisville": "Louisville",
  },
  "LA": {
    "baton-rouge": "Baton Rouge",
    "lafayette": "Lafayette",
    "new-orleans": "New Orleans",
    "shreveport": "Shreveport",
  },
  "MA": {
    "boston": "Boston",
    "cambridge": "Cambridge",
    "peabody": "Peabody",
    "springfield": "Springfield",
    "worcester": "Worcester",
  },
  "MD": {
    "baltimore": "Baltimore",
    "bethesda": "Bethesda",
  },
  "ME": {
    "portland-maine": "Portland",
  },
  "MI": {
    "ann-arbor": "Ann Arbor",
    "detroit": "Detroit",
    "flint": "Flint",
    "grand-rapids": "Grand Rapids",
    "holland-grand-haven": "Holland / Grand Haven",
    "kalamazoo": "Kalamazoo",
    "lansing": "Lansing",
  },
  "MN": {
    "duluth": "Duluth",
    "minneapolis": "Minneapolis",
  },
  "MO": {
    "kansas-city": "Kansas City",
    "springfield-mo": "Springfield",
    "st-louis": "St. Louis",
  },
  "MS": {
    "jackson": "Jackson",
  },
  "NC": {
    "ashville": "Asheville",
    "charlotte": "Charlotte",
    "durham": "Durham",
    "fayetteville-nc": "Fayetteville",
    "greensboro": "Greensboro",
    "raleigh": "Raleigh",
    "wilmington-nc": "Wilmington",
    "winston-salem": "Winston-Salem",
  },
  "NE": {
    "lincoln": "Lincoln",
    "omaha": "Omaha",
  },
  "NH": {
    "manchester": "Manchester",
    "rockingham": "Rockingham",
  },
  "NJ": {
    "atlantic-city": "Atlantic City",
    "camden": "Camden",
    "edison": "Edison",
    "newark": "Newark",
    "trenton": "Trenton",
  },
  "NM": {
    "albuquerque": "Albuquerque",
    "las-cruces": "Las Cruces",
    "santa-fe": "Santa Fe",
  },
  "NV": {
    "las-vegas": "Las Vegas",
    "reno": "Reno",
  },
  "NY": {
    "albany": "Albany",
    "bighamton": "Binghamton",
    "buffalo": "Buffalo",
    "nassau": "Nassau",
    "new-york-city": "New York City",
    "poughkeepsie": "Poughkeepsie",
    "rochester": "Rochester",
    "syracuse": "Syracuse",
    "utica": "Utica",
  },
  "OH": {
    "akron": "Akron",
    "canton": "Canton",
    "cincinnati": "Cincinnati",
    "cleveland": "Cleveland",
    "columbus": "Columbus",
    "dayton": "Dayton",
    "toledo": "Toledo",
    "youngstown": "Youngstown",
  },
  "OK": {
    "oklahoma-city": "Oklahoma City",
    "tulsa": "Tulsa",
  },
  "OR": {
    "eugene": "Eugene",
    "portland": "Portland",
    "salem": "Salem",
  },
  "PA": {
    "allentown": "Allentown",
    "erie": "Erie",
    "harrisburg": "Harrisburg",
    "lancaster": "Lancaster",
    "philadelphia": "Philadelphia",
    "pittsburgh": "Pittsburgh",
    "reading": "Reading",
    "scranton": "Scranton",
    "york": "York",
  },
  "RI": {
    "providence": "Providence",
  },
  "SC": {
    "charleston": "Charleston",
    "columbia": "Columbia",
    "greenville": "Greenville",
    "myrtle-beach": "Myrtle Beach",
    "spartanburg": "Spartanburg",
  },
  "TN": {
    "chattanooga": "Chattanooga",
    "clarksville": "Clarksville",
    "kingsport": "Kingsport",
    "knoxville": "Knoxville",
    "memphis": "Memphis",
    "nashville": "Nashville",
  },
  "TX": {
    "amarillo": "Amarillo",
    "austin": "Austin",
    "beaumont": "Beaumont",
    "brownsville": "Brownsville",
    "corpus-christi": "Corpus Christi",
    "dallas": "Dallas",
    "el-paso": "El Paso",
    "fort-worth": "Fort Worth",
    "houston": "Houston",
    "kileen": "Killeen",
    "laredo": "Laredo",
    "lubbock": "Lubbock",
    "mcallen": "McAllen",
    "san-antonio": "San Antonio",
  },
  "UT": {
    "ogden": "Ogden",
    "provo": "Provo",
    "salt-lake-city": "Salt Lake City",
  },
  "VA": {
    "lynchburg": "Lynchburg",
    "richmond": "Richmond",
    "roanoke": "Roanoke",
    "virginia-beach": "Virginia Beach",
  },
  "WA": {
    "bremerton-silverdale": "Bremerton / Silverdale",
    "kennewick-richland-pasco": "Kennewick / Richland / Pasco",
    "olympia": "Olympia",
    "seattle": "Seattle",
    "spokane": "Spokane",
    "tacoma": "Tacoma",
    "yakima": "Yakima",
  },
  "WI": {
    "greenbay": "Green Bay",
    "madison": "Madison",
    "milwaukee": "Milwaukee",
  },
  "WV": {
    "charleston-wv": "Charleston",
    "huntingtons-ashland": "Huntington / Ashland",
  },
};
